export const DAMAGE_STOCK_REPORT_GO_BUTTON_API = 'DAMAGE_STOCK_REPORT_GO_BUTTON_API'
export const DAMAGE_STOCK_REPORT_GO_BUTTON_API_SUCCESS = 'DAMAGE_STOCK_REPORT_GO_BUTTON_API_SUCCESS'


export const DAMAGE_STOCK_REPORT_API_ERROR_ACTION = 'DAMAGE_STOCK_REPORT_API_ERROR_ACTION'